
import { getBackstageSimList } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import outTest from "./components/sim-out-test.vue";
import simApply from "./components/sim-apply.vue";
import { optionKey, getOptionList } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {
    outTest,
    simApply
  }
})
export default class PiSimOutTest extends Vue {
  private formInline: objAny = {
    applicantOrCaller: "",
    projectName: "",
    pileNoOrIccid: "",
    endTime: "",
    startTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalOrder: "",
    simStatus: ""
  };

  private simStatusList: object[] = [];
  private simCardList: object[] = [];
  private loading = false;
  private total = 0;
  private time: object[] = [];
  private selectList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("simOutTest.projectName"),
      key: "projectName",
      minWidth: 120
    },
    {
      title: i18n.t("simOutTest.serialNumber"),
      key: "serialNumber",
      minWidth: 120
    },
    {
      title: "ICCID",
      key: "iccid",
      minWidth: 120
    },
    {
      title: i18n.t("simOutTest.applicant"),
      key: "applicant",
      minWidth: 90
    },
    {
      title: i18n.t("simOutTest.caller"),
      key: "caller",
      minWidth: 90
    },
    {
      title: i18n.t("simOutTest.outgoer"),
      key: "outgoer",
      minWidth: 90
    },
    {
      title: i18n.t("simOutTest.createTime"),
      key: "createTime",
      minWidth: 140
    },
    {
      title: i18n.t("simOutTest.modifyTime"),
      key: "modifyTime",
      minWidth: 140
    },
    {
      title: i18n.t("simOutTest.simStatus"),
      key: "simStatusDesc",
      minWidth: 80
    }
    // {
    //   title: i18n.t("operation"),
    //   slot: "action",
    //   minWidth: 160
    // }
  ];

  async qyeryClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    // this.getTableList();
  }
  public selectItem(list: object[]) {
    this.selectList = list;
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }
  async getTableList() {
    this.loading = true;
    const ret = await getBackstageSimList(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
      this.selectList = [];
    }
    this.loading = false;
  }
  public outTestClick() {
    const outTest: objAny = this.$refs.outTest;
    outTest.open();
  }
  public simApplyClick() {
    const simApply: objAny = this.$refs.simApply;
    simApply.open();
  }
  public syncClick(item: objAny) {}

  async getOptionList() {
    const data = await getOptionList([optionKey.simStatus]);
    this.simStatusList = data[optionKey.simStatus];
  }

  mounted() {
    this.getTableList();
    this.getOptionList();
  }
}
